import {
  Component,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core'
import { NavbarService } from '../../services/navbar.service'
import { RouterModule } from '@angular/router'

@Component({
  selector: 'app-auth',
  imports: [RouterModule],
  templateUrl: './auth.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './auth.component.scss',
})
export class AuthComponent implements OnInit {
  private navBarService = inject(NavbarService)

  ngOnInit(): void {
    this.navBarService.hideNavBar()
  }
}
